import { createAction, props } from '@ngrx/store';

import { GenerateBusinessCardMethod } from './generate-business-card.models';

export const generateBusinessCard = createAction(
  '[Tracking][BAU365] Generate Business Card',
  props<{ method: GenerateBusinessCardMethod }>()
);
